import { useEffect, useState } from "react";

import { DataGrid, GridColDef, GridRowsProp } from "@mui/x-data-grid";

import { CustomPagination } from "../../../../components/CustomPagination";
import { NoRowsOverlay } from "../../../../components/NoRowsOverlay";
import { useAlerting, usePermission, useTranslation } from "../../../../hooks";
import useColumnHide, {
  ColumnHiddenMessage,
  getColumnHideConfig,
} from "../../../../hooks/useColumnHide";
import { dataGridDefaults } from "../../../../utils/constant";
import { useGenGridCol } from "../../../../utils/HelperComp";
import { useZusParams } from "./index";

interface IProps {
  listMapping: (which: "key" | "name", array: any[], config?: any) => any[][];
  listRes: any;
}

function RentRequestList(props: IProps) {
  // const [isRentDialogOpen, setIsRentDialogOpen] = useState(false);

  const { t, te } = useTranslation("tronWalletResourceBalance");
  const { listMapping, listRes } = props;
  const { hasPermission } = usePermission();
  const zusParams = useZusParams();

  const { rows = [], count = 0 } = listRes?.data || { rows: [], count: 0 };
  const content: GridRowsProp = listMapping("key", rows, {
    t,
    te,
  });

  const [selectedRowData, setSelectedRowData] = useState<any>({});
  const { alerting } = useAlerting();

  const columns: GridColDef[] = [
    // useGenGridCol("batchId", t("batchId")),
    // useGenGridCol("stepSequence", t("stepSequence")),
    useGenGridCol("orderId", t("orderId"), {
      minWidth: 180,
    }),
    // useGenGridCol("transactionSequence", t("transactionSequence")),
    useGenGridCol("chainName", t("chainName")),
    useGenGridCol("walletType", t("walletType")),
    useGenGridCol("wallet_address", t("wallet_address")),
    useGenGridCol("status", t("status")),
    useGenGridCol("requiredEnergy", t("requiredEnergy")),
    useGenGridCol("requiredBandwidth", t("requiredBandwidth")),
    useGenGridCol("lastBandwidthBlockNumber", t("lastBandwidthBlockNumber")),
    useGenGridCol("lastEnergyBlockNumber", t("lastEnergyBlockNumber")),
    useGenGridCol("duration", t("duration")),
    useGenGridCol("created_date", t("created_date")),
    useGenGridCol("last_modified_date", t("last_modified_time")),
  ].filter((col) => {
    // if (col.field === "operation" && !hasPermission(Pkey.Edit)) {
    //   return false;
    // }
    return true;
  }) as GridColDef[];

  useEffect(() => () => zusParams.clear(), []);
  const { colsShown, setColsShown, hasColHidden, localeText } = useColumnHide(
    columns,
    getColumnHideConfig()
  );
  return (
    <>
      <ColumnHiddenMessage hasColHidden={hasColHidden} />
      <DataGrid
        {...dataGridDefaults}
        localeText={localeText}
        columnVisibilityModel={colsShown}
        onColumnVisibilityModelChange={setColsShown}
        rows={content}
        columns={columns}
        rowCount={count || 0}
        onPageChange={zusParams.setPage}
        page={zusParams.body.page}
        components={{
          NoRowsOverlay,
          Footer: CustomPagination,
        }}
        componentsProps={{
          footer: { totalRecords: count },
        }}
      />
    </>
  );
}

export default RentRequestList;
